import { c as _c } from "react/compiler-runtime";
import { showError } from 'components/notify';
import { usePortal } from 'components/portal/portal';
import { customAlphabet, urlAlphabet } from 'nanoid';
import { asyncMap } from 'modern-async';
import { useState } from 'react';
import { sb } from 'utils/db';
const makeId = customAlphabet(urlAlphabet, 10);
export const useUpload = () => {
  const $ = _c(10);
  const {
    profile
  } = usePortal();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = sb.storage.from("upload");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const up = t0;
  const [uploading, setUploading] = useState(false);
  let t1;
  if ($[1] !== profile) {
    t1 = async file => {
      if (!profile) {
        throw new Error("profile not found");
      }
      const path = `${profile.id}/${makeId()}`;
      const name = file.name.split(".").slice(0, -1).join(".");
      setUploading(true);
      return up.upload(path, file).then(upRes => {
        if (upRes.error) {
          showError(upRes.error, "Error uploading");
        }
        return upRes.error ? {
          error: upRes.error
        } : {
          path: upRes.data.path,
          url: up.getPublicUrl(path).data.publicUrl,
          name,
          type: file.type
        };
      }).finally(() => setUploading(false));
    };
    $[1] = profile;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const upload = t1;
  let t2;
  if ($[3] !== upload) {
    t2 = files => asyncMap(files, upload, 4);
    $[3] = upload;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const uploads = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = path_0 => up.getPublicUrl(path_0).data.publicUrl;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const uploadUrl = t3;
  let t4;
  if ($[6] !== upload || $[7] !== uploading || $[8] !== uploads) {
    t4 = {
      upload,
      uploads,
      uploadUrl,
      uploading
    };
    $[6] = upload;
    $[7] = uploading;
    $[8] = uploads;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};